import { useIntl } from "react-intl";
import { useState } from "react";
import styles from "./CompanyRateCodeModalTrigger.module.scss";
import { CompanyRateCodeModal } from "./companyRateCodeModal/CompanyRateCodeModal";

type CompanyRateCodeModalTriggrProps = {
  updateCompanyRateCode: (string) => void;
};

export const CompanyRateCodeModalTrigger = ({
  updateCompanyRateCode,
}: CompanyRateCodeModalTriggrProps) => {
  const intl = useIntl();
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);

  const handleOnLabelClick = () => {
    setIsModalOpened(!isModalOpened);
  };

  return (
    <>
      <div className={styles.modalTriggerLabel} onClick={handleOnLabelClick}>
        {intl.formatMessage({ id: "companyRateCodeModalTriggerLabel" })}
      </div>
      <div>
        {isModalOpened && (
          <CompanyRateCodeModal
            isOpen={isModalOpened}
            setIsOpen={setIsModalOpened}
            updateCompanyRateCode={updateCompanyRateCode}
          ></CompanyRateCodeModal>
        )}
      </div>
    </>
  );
};
